import { history } from 'ice';
import React from 'react';
import styles from './MobileHomeHotMessageLimit2.module.scss';
import moment from 'moment';
const MobileHomeHotMessageLimit2 = (props) => {
  return (
    <>
      <div
        className={styles.item}
        onClick={() => {
          history.push('/mobile/postal/postalFrontDesk');
        }}
      >
        <div className={styles.t1}>
          <span>郵件包裹</span>
        </div>
        <div className={styles.t2}>
          <p className={styles.title}>
            {props.packageType}({props.placement})
          </p>
          <p className={styles.time}>
            {moment(props.packagerRegistrationTime).format('YYYY-MM-DD')}
          </p>
        </div>
        {/* <div className={styles.t3}>
          {props.vendor}({props.logistics})
        </div> */}
      </div>
    </>
  );
};

export default MobileHomeHotMessageLimit2;
